//================================================================
//  Component: AccessDenied component
//================================================================

//  Purpose: This is used in PageComponent when status is access denied for perticular page

//  Properties:
//    - poratal = {A string, portal name : Inventory , Demand Managment, Commercial, ...}

//  Example:
//    <AccessDenied
//      portal={'Demand Management'}
//    ></AccessDenied>  

//================================================================


//Libraries
import React, { useState, useContext } from 'react';

//Contexts
import { GetUser } from '../../../Library/GlobalContexts';

//Components

//Functions
import WriteDocument from '../../../Library/WriteDocument';

//Images
import UnauthorisedUser from '../../Images/Splash/Error_Unauthorised.svg';


//CSS


export default function AccessDenied(
  {
    portal
  }
) {

  //------------------------------------------------------
  //  useContexts
  //------------------------------------------------------

  const getUser = useContext(GetUser);


  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

  const [reason, setReason] = useState('');

  const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'

  const [error, setError] = useState('');



  //------------------------------------------------------
  //  Functions
  //------------------------------------------------------

  //Returns the style of each component
  function submitRequest() {

    if (!reason.trim()) return;

    setSubmitStatus('submitting');
    setError('');

    // Generate a unique case ID based on the current timestamp
    const caseid = `inc-${Date.now()}`;

    const support = {
      'caseid': caseid,
      'portal': portal,
      'casetype': 'Issue',
      'description': `Grant ${getUser?.givenname} ${getUser?.surname} access to ${portal}. Reason: “${reason}"`,
      'link': window.location.href,
      'permissionlevel': '',
      'createdby': {
        'email': getUser?.emailaddress,
        'givenname': getUser?.givenname,
        'surname': getUser?.surname
      },
    }


    WriteDocument('support', caseid, support, true)
      .then(() => {

        setSubmitStatus('success');
        setReason('');

      })
      .catch((error) => {

        setSubmitStatus('error');
        setError('Something went wrong. Please try again.');
      });

  }


  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------



  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <div className='p-[2% 4%] flex items-center justify-center mt-5 gap-[48px] min-h-[35vh]'>
      <img src={UnauthorisedUser} height={250} width={250} alt='Grumpy-Cat'></img>

      <div className='flex flex-col items-start'>
        <p className='text-[24px] font-medium mb-0'>You’re not authorised to view this page</p>
        <p className='text-[18px]'>Let us know why you need access:</p>


        {submitStatus === 'success' && (
          <div className="w-full px-3 py-2 mb-2 bg-[#E7F2DA] border-l-4 border-[#8ABB45]">
            <p className="mb-0 text-gray-600">Successfully submitted.</p>
          </div>
        )}


        {submitStatus === 'error' && (
          <div className="w-full px-3 py-2 mb-2 bg-[#FCF4F6] border-l-4 border-[#C4314B]">
            <p className="mb-0 text-gray-600">{error}</p>
          </div>
        )}

        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          id="message"
          rows="4"
          className="block p-2.5 w-[40vw] text-sm rounded-lg border"
          placeholder="Enter your reason here...">
        </textarea>

        <div className="w-full flex justify-end mt-2">

          <button
            className='Primary-Button disabled:opacity-50 disabled:cursor-not-allowed'
            onClick={submitRequest}
            disabled={submitStatus === 'submitting' || reason.trim() === ''}
          >
            {submitStatus === 'submitting' ? 'Submitting...' : 'Submit'}

          </button>
        </div>
      </div>
    </div>
  )
}
